import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../axios-backend";
import Line from "../main/Line";
import Button from "../main/Button";
import BackButton from "../main/BackButton";

const AdVideo = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [video, setVideo] = useState();

  const handleUpload = () => {
    let formData = new FormData();
    formData.append("video", video);
    formData.append("productId", id);

    axios({
      method: "post",
      url: "/upload-video",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((data) => {
        if (data.data.status === 200) {
          navigate(-1);
        } else {
          alert(data.data.msg);
        }
      })
      .catch((r) => {
        console.log(r);
      });
  };

  const handleChangeVideo = (e) => {
    const file = e.target.files[0];
    if (file) {
      setVideo(file);
    } else {
      alert("please select a file");
      return;
    }
  };
  return (
    <div style={{ height: "100%" }}>
      <BackButton />
      <Line type="bottom-line">Page for adding video to product</Line>
      <Line type="bottom-line">
        <input
          type="file"
          accept="video/*"
          onChange={handleChangeVideo}
          name="file"
          multiple
        />
      </Line>
      <Line type="bottom-line">
        <Button onClick={handleUpload}>Upload</Button>
      </Line>
      <Line type="bottom-line"></Line>
      <Line type="bottom-line"></Line>
      <Line type="bottom-line"></Line>
      <Line type="bottom-line"></Line>
      <Line type="bottom-line"></Line>
      <Line type="bottom-line"></Line>
      <Line type="bottom-line"></Line>
      <Line type="bottom-line"></Line>
    </div>
  );
};

export default AdVideo;
